/* tslint:disable */
/* eslint-disable */
/**
 * Notes API
 * API for managing notes with tags, mentions and attachments
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PersonMinimalDto } from './PersonMinimalDto';
import {
    PersonMinimalDtoFromJSON,
    PersonMinimalDtoFromJSONTyped,
    PersonMinimalDtoToJSON,
    PersonMinimalDtoToJSONTyped,
} from './PersonMinimalDto';
import type { ReferentielMinimalDto } from './ReferentielMinimalDto';
import {
    ReferentielMinimalDtoFromJSON,
    ReferentielMinimalDtoFromJSONTyped,
    ReferentielMinimalDtoToJSON,
    ReferentielMinimalDtoToJSONTyped,
} from './ReferentielMinimalDto';
import type { TagNoteDto } from './TagNoteDto';
import {
    TagNoteDtoFromJSON,
    TagNoteDtoFromJSONTyped,
    TagNoteDtoToJSON,
    TagNoteDtoToJSONTyped,
} from './TagNoteDto';

/**
 * Note item for list display
 * @export
 * @interface NoteListItemDto
 */
export interface NoteListItemDto {
    /**
     * Unique identifier of the note
     * @type {string}
     * @memberof NoteListItemDto
     */
    id?: string;
    /**
     * Title of the note
     * @type {string}
     * @memberof NoteListItemDto
     */
    title?: string;
    /**
     * Content excerpt (first 200 characters)
     * @type {string}
     * @memberof NoteListItemDto
     */
    contentExcerpt?: string;
    /**
     * Due date — date CALENDAIRE ("yyyy-MM-dd" en envoi, ISO sans Z en lecture), jamais de conversion de fuseau
     * @type {string}
     * @memberof NoteListItemDto
     */
    dueDate?: string | null;
    /**
     * 
     * @type {ReferentielMinimalDto}
     * @memberof NoteListItemDto
     */
    priority?: ReferentielMinimalDto;
    /**
     * 
     * @type {ReferentielMinimalDto}
     * @memberof NoteListItemDto
     */
    status?: ReferentielMinimalDto;
    /**
     * List of tags associated with the note
     * @type {Array<TagNoteDto>}
     * @memberof NoteListItemDto
     */
    tags?: Array<TagNoteDto>;
    /**
     * List of persons mentioned in the note
     * @type {Array<PersonMinimalDto>}
     * @memberof NoteListItemDto
     */
    mentions?: Array<PersonMinimalDto>;
    /**
     * Number of attachments
     * @type {number}
     * @memberof NoteListItemDto
     */
    attachmentsCount?: number;
    /**
     * Creation date of the note
     * @type {Date}
     * @memberof NoteListItemDto
     */
    creationTime?: Date;
    /**
     * Relative time since creation (e.g., "1 day", "2 hours")
     * @type {string}
     * @memberof NoteListItemDto
     */
    relativeTime?: string;
}

/**
 * Check if a given object implements the NoteListItemDto interface.
 */
export function instanceOfNoteListItemDto(value: object): value is NoteListItemDto {
    return true;
}

export function NoteListItemDtoFromJSON(json: any): NoteListItemDto {
    return NoteListItemDtoFromJSONTyped(json, false);
}

export function NoteListItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NoteListItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'title': json['title'] == null ? undefined : json['title'],
        'contentExcerpt': json['contentExcerpt'] == null ? undefined : json['contentExcerpt'],
        'dueDate': json['dueDate'] == null ? undefined : json['dueDate'],
        'priority': json['priority'] == null ? undefined : ReferentielMinimalDtoFromJSON(json['priority']),
        'status': json['status'] == null ? undefined : ReferentielMinimalDtoFromJSON(json['status']),
        'tags': json['tags'] == null ? undefined : ((json['tags'] as Array<any>).map(TagNoteDtoFromJSON)),
        'mentions': json['mentions'] == null ? undefined : ((json['mentions'] as Array<any>).map(PersonMinimalDtoFromJSON)),
        'attachmentsCount': json['attachmentsCount'] == null ? undefined : json['attachmentsCount'],
        'creationTime': json['creationTime'] == null ? undefined : (new Date(json['creationTime'])),
        'relativeTime': json['relativeTime'] == null ? undefined : json['relativeTime'],
    };
}

export function NoteListItemDtoToJSON(json: any): NoteListItemDto {
    return NoteListItemDtoToJSONTyped(json, false);
}

export function NoteListItemDtoToJSONTyped(value?: NoteListItemDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'title': value['title'],
        'contentExcerpt': value['contentExcerpt'],
        'dueDate': value['dueDate'],
        'priority': ReferentielMinimalDtoToJSON(value['priority']),
        'status': ReferentielMinimalDtoToJSON(value['status']),
        'tags': value['tags'] == null ? undefined : ((value['tags'] as Array<any>).map(TagNoteDtoToJSON)),
        'mentions': value['mentions'] == null ? undefined : ((value['mentions'] as Array<any>).map(PersonMinimalDtoToJSON)),
        'attachmentsCount': value['attachmentsCount'],
        'creationTime': value['creationTime'] == null ? undefined : ((value['creationTime']).toISOString()),
        'relativeTime': value['relativeTime'],
    };
}

